export default __webpack_public_path__ + "static/media/popup.e25b7f8c.svg";